import React, { useState } from 'react';
import { TabsContainer, TabButtons, TabContent } from './SegmentSelection.Styled';
import DynamicContent from './DynamicContent';
import {
  selectAddition,
  selectReplace,
  selectPricingAndDistribution,
  selectSegmentError,
  selectSegmentLoading,
  resetStatesWithAvailablePackSegments,
  setIsPackReplacable,
} from '../../../../features/packSegments/packSegmentsSlice';
import { useAppDispatch, useAppSelector } from '../../../../state/hooks';
import { resetInputKpiState, setCurrentTab } from '../../../../features/inputKpi/inputKpiSlice';
import { setSelectedAvailablePack, setSelectedSegment } from '../../../../components/FormComponent/formSlice';
import { toggleEnableReviewTableBtn } from '../ReviewTable/reviewTableSlice';
import { VerticalLine } from '../../../../components/FormComponent/FormStyles.Styled';

const SegmentSelection: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useAppDispatch();
  const pricingAndDistribution = useAppSelector(selectPricingAndDistribution);
  const replace = useAppSelector(selectReplace);
  const addition = useAppSelector(selectAddition);
  const loading = useAppSelector(selectSegmentLoading);
  const error = useAppSelector(selectSegmentError);

  const formatSegmentData = () => [
    {
      label: 'Pricing & Distribution',
      content: {
        type: 'custom',
        data: [pricingAndDistribution],
      },
    },
    {
      label: 'Replace',
      content: {
        type: 'replace',
        data: [replace],
      },
    },
    {
      label: 'Launch',
      content: {
        type: 'launch',
        data: [addition],
      },
    },
  ];

  const tabs = formatSegmentData();
  const handleActiveTab = (index: number) => {
    dispatch(setCurrentTab(tabs[index].label));
    dispatch(setSelectedAvailablePack(null));
    dispatch(resetInputKpiState());
    // dispatch(toggleEnableReviewTableBtn(false));
    dispatch(setSelectedSegment(''));
    dispatch(resetStatesWithAvailablePackSegments());
    dispatch(setIsPackReplacable(false));
    setActiveTab(index);
  };

  return (
    <TabsContainer>
      <TabButtons>
        {tabs.map((tab, index) => (
          <>
            <div
              key={index}
              style={{
                marginTop: '5px',
                cursor: 'pointer',
                color: `${index === activeTab ? 'red' : 'black'}`,
              }}
              onClick={() => handleActiveTab(index)}
            >
              {tab.label}
            </div>
            {index !== tabs.length - 1 && <hr style={{ height: '15px', marginTop: '5px' }} />}
          </>
        ))}
      </TabButtons>
      <TabContent>
        <DynamicContent content={tabs[activeTab].content} selectedTab={tabs[activeTab].label} />
      </TabContent>
    </TabsContainer>
  );
};

export default SegmentSelection;
